import script from "./TitleCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleCard.vue?vue&type=script&lang=ts&setup=true"

import "./TitleCard.vue?vue&type=style&index=0&id=298c30fa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shiyu\\local_document\\projects\\vue\\hsmkai.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298c30fa"]])

export default __exports__